import {html, css, LitElement} from 'lit';

export class DzTabSwitch extends LitElement {

    static get properties() {
        return {
            choise: { type: String, reflect: true }
        }
    }
    
    constructor() {
        super()
        this.choise = ""
    }

    connectedCallback() {
        super.connectedCallback()
        this.addEventListener("switch", evt => {
            this.choise = evt.detail
            this.performUpdate()
        })
    }

    render() {
        return html`
            <slot name="tabs"></slot>
            <slot name="${this.choise}"></slot>
        `
    }

}

customElements.define('dz-tab-switch', DzTabSwitch)